import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function ToolRouteIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
 <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" fill="currentcolor"
	 width="100px" height="100px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve">
<path d="M52.316,83.431H34.518v-8h17.797c3.482,0,4.771-2.687,5.082-3.51c0.312-0.823,1.127-3.688-1.481-5.995L26.683,40.067
	c-4.221-3.734-5.659-9.553-3.662-14.823c1.997-5.27,6.928-8.675,12.563-8.675H56.85v8H35.584c-3.482,0-4.77,2.686-5.082,3.509
	c-0.312,0.823-1.127,3.689,1.482,5.997l29.233,25.858c4.221,3.733,5.658,9.552,3.662,14.821
	C62.883,80.025,57.952,83.431,52.316,83.431z"/>
<path d="M15.6,92.331c-7.113,0-12.9-5.787-12.9-12.9s5.787-12.9,12.9-12.9s12.9,5.787,12.9,12.9S22.714,92.331,15.6,92.331z
	 M15.6,74.331c-2.812,0-5.1,2.287-5.1,5.1s2.288,5.1,5.1,5.1s5.1-2.287,5.1-5.1S18.412,74.331,15.6,74.331z"/>
<path d="M80.299,3.57c-9.389,0-17,7.611-17,17c0,9.389,7.611,17,17,17s17-7.611,17-17C97.299,11.181,89.688,3.57,80.299,3.57z
	 M90.924,23.569h-7.625v7.625h-6v-7.625h-7.625v-6h7.625V9.944h6v7.625h7.625V23.569z"/>
</svg>

  </SvgIcon>
}

export default ToolRouteIcon;
